import API from './API.js';
export default class MasterDiscussion extends API {
    constructor() {
        super('masterDiscussion');
    }

}
